import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6966728e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "dialog-overlay" }
const _hoisted_2 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog"
}
const _hoisted_3 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, _hoisted_8)
          ]),
          _renderSlot(_ctx.$slots, "modal-content", {}, undefined, true)
        ])
      ])
    ])
  ]))
}